import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { useDispatch, useSelector } from "../../../../redux/store";
import { getProfile } from "../../../../redux/slices/user";
import PaymentIcon from "@mui/icons-material/Payment";
import {
  Grid,
  Skeleton,
  Typography,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from '@mui/material/CircularProgress';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  listCardDetails,
  deleteCardDetails,
} from "../../../../redux/slices/cards";

const cardDetails = [
  {
    cardImgSrc: "/img/cardDetails/card5.png",
    cardType: "Visa Card",
    cardNumber: "XXXX XXXX XXXX X105",
    cardLogoSrc: "/img/cardDetails/visaLogo2.png",
    cardBalance: "AED 4.50",
  },
  {
    cardImgSrc: "/img/cardDetails/card5.png",
    cardType: "Visa Card",
    cardNumber: "XXXX XXXX XXXX X105",
    cardLogoSrc: "/img/cardDetails/visaLogo2.png",
    cardBalance: "AED 5.10",
  },
];

const Index = ({ handleClickOpen, setCardList }) => {
  const dispatch = useDispatch();
  const [userId, setUserId] = useState(null);
  const [details, setDetails] = useState("");
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [cardToDelete, setCardToDelete] = useState(null);
  const { listCardDetailsNew, deleteCardDetailsNew } = useSelector(
    (state) => state.cards
  );

  useEffect(() => {
    // Parse the 'rslkey' from sessionStorage
    const rslKey = JSON.parse(sessionStorage.getItem("rslkey"));
    const rslkeyId = JSON.parse(sessionStorage.getItem("rslkeyId")) || 0;
    const email = JSON.parse(sessionStorage.getItem("userEmail") || "{}");
    const userName = JSON.parse(sessionStorage.getItem("userName") || "{}");

    const countryCodeString = sessionStorage.getItem("countryCode");
    let countryCode;

    try {
      countryCode = countryCodeString
        ? JSON.parse(countryCodeString)
        : undefined;
    } catch (error) {
      console.error("Error parsing 'countryCode':", error);
      countryCode = undefined;
    }

    const phoneString = sessionStorage.getItem("phone");
    let phone;

    try {
      phone = phoneString ? JSON.parse(phoneString) : undefined;
    } catch (error) {
      console.error("Error parsing 'countryCode':", error);
      phone = undefined;
    }
    const ref = sessionStorage.getItem("refKey") || "{}";

    // if (rslKey) {
    setUserId(rslKey);
    const obj = {
      passenger_id: rslkeyId,
      userId: rslKey,
      email: email,
      countryCode: countryCode,
      userName: userName,
      phone: phone,
      name: userName,
      type: "0",
      card_type: "",
      defValue: "",
      payment_mode: "1",
    };
    setLoader(true);
    dispatch(listCardDetails(obj));
    // }
  }, []);

  useEffect(() => {
    if (listCardDetailsNew) {
      setLoader(false);
      if (listCardDetailsNew?.detail) {
        setMessage("");
        setDetails(listCardDetailsNew?.detail);
        setCardList(listCardDetailsNew?.detail);
      } else {
        setDetails([]);
        setMessage(listCardDetailsNew?.message);
        setCardList([]);
      }
    }
  }, [listCardDetailsNew]);

  // Delete Api

  const handleDeleteCard = (passenger_cardid) => {
    setCardToDelete(passenger_cardid);
    setConfirmationOpen(true);
  };

  const handleConfirmationClose = () => {
    setConfirmationOpen(false);
  };

  const handleConfirmationYes = () => {
    if (cardToDelete) {
      const rslKey = JSON.parse(sessionStorage.getItem("rslkey") || "{}");
      const email = JSON.parse(sessionStorage.getItem("userEmail") || "{}");
      const userName = JSON.parse(sessionStorage.getItem("userName") || "{}");

      const countryCodeString = sessionStorage.getItem("countryCode");
      let countryCode;

      try {
        countryCode = countryCodeString
          ? JSON.parse(countryCodeString)
          : undefined;
      } catch (error) {
        console.error("Error parsing 'countryCode':", error);
        countryCode = undefined;
      }

      const phoneString = sessionStorage.getItem("phone");
      let phone;
      setLoading(true)
      try {
        phone = phoneString ? JSON.parse(phoneString) : undefined;
      } catch (error) {
        console.error("Error parsing 'countryCode':", error);
        phone = undefined;
      }

      const obj = {
        userId: rslKey,
        email: email,
        countryCode: countryCode,
        phone: phone,
        name: userName,
        type: "0",
        passenger_cardid: cardToDelete,
        passenger_id: JSON.parse(sessionStorage.getItem('rslkeyId'))
      };

      dispatch(deleteCardDetails(obj));
      setConfirmationOpen(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000)
      // window.location.reload();
    }
  };

  useEffect(() => {
    if (deleteCardDetailsNew?.status === 1) {
      setLoading(false);
    }
  }, [deleteCardDetailsNew]);

  return (
    <>
      <div>
        {loader ? (
          <>
            <Skeleton container height={300} />
          </>
        ) : (
          <>
            {/* Show Existing Cards */}
            {details && details.length !== 0 && (
              <div className="card-scroll-container">
                <div className="card-container card-row card-res">
                  {details.map((card, index) => (
                    <div key={index} className="card-wrapper">


                      <div className="card-title1">
                        <div>BANK NAME</div>
                      </div>

                      <img
                        src="/img/walletcard/card1.svg"
                        alt="creditcard"
                        className="card-img"
                      />

                      <div className="card-info">
                        <div className="card-number">{card.creditcard_no}</div>

                        <div className="card-bottom">
                          <span className="holder-name">CARDHOLDER NAME</span>

                          <div className="expiry-block">
                            <span className="valid-label">VALID<br />THRU</span>
                            <span className="expiry-date">
                              {(card.expdatemonth || "08")}/{(card.expdateyear || "28")}
                            </span>
                          </div>
                        </div>
                      </div>


                      {/* <div className="card-info-right">
                        <DeleteIcon
                          sx={{ color: "red", cursor: "pointer" }}
                          onClick={() => handleDeleteCard(card.passenger_cardid)}
                        />
                      </div> */}

                    </div>
                  ))}

                  <div className="add-card-box" onClick={handleClickOpen}>
                    <span className="add-card-plus">+</span>
                  </div>
                </div>
              </div>

            )}
            {/* <div className="add-card-section">
              <Typography
                variant="body1"
                sx={{ color: "red", textAlign: "center" }}
              >
                {message}
                <div style={{
                  border: "1px solid #35D0D1",
                  marginTop: "10px",
                  borderRadius: "6px",
                }}>
                  <button
                    className="btn"
                    style={{
                      backgroundColor: "transparent",
                      width: "100%",
                      color: "#35D0D1",
                      padding: "5px 20px",
                      borderRadius: "6px",
                      transition: "background-color 0.3s ease-in-out, color 0.3s ease-in-out, border 0.3s ease-in-out",
                    }}
                    onClick={handleClickOpen}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#35D0D1";
                      e.target.style.color = "#fff"; // Ensure text color changes on hover
                      e.target.style.border = "1px solid #35D0D1"; // Reinforce border
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#35D0D1";
                      e.target.style.border = "1px solid #35D0D1"; // Ensure border remains after hover
                    }}
                  >
                    + Add Card
                  </button>
                </div>

             
              </Typography>
            </div> */}



          </>
        )}
      </div>

      <Dialog
        open={confirmationOpen}
        onClose={handleConfirmationClose}
      // TransitionComponent={Transition}
      // PaperProps={{
      //   className: isMobile ? "dialog-fullscreen" : "dialog-container",
      // }}
      >
        {/* Header with Warning Icon */}
        <DialogTitle className="dialog-header">
          <Box className="dialog-header">
            <WarningAmberIcon className="dialog-icon" />
            <span className="dialog-title">
              Confirmation Required
            </span>
          </Box>
        </DialogTitle>

        {/* Dialog Content */}
        <DialogContent>
          <DialogContentText className="dialog-content-text">
            Are you sure you want to delete This Card?
          </DialogContentText>
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions className="dialog-actions">
          {/* Disagree Button - Styled in Red */}
          <Button onClick={handleConfirmationClose} variant="contained" className="button-disagree">
            No
          </Button>

          {/* Agree Button with Loading Spinner */}
          <Button
            variant="contained"
            autoFocus
            onClick={handleConfirmationYes}
            disabled={loading}
            className="button-agree"
          >
            {loading ? <CircularProgress size={24} sx={{ color: "#ffffff" }} /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Dialog
        open={confirmationOpen}
        onClose={handleConfirmationClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete This Card?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this card?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmationClose} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmationYes} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
};

export default Index;
